/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

// Fake Quick Add → forward to theme's real Quick Add button
// Debug-heavy build

(function () {
  const DEBUG = true; // flip to false to quiet logs
  const DRAG_PX_THRESHOLD = 6; // ignore clicks if pointer moved > N px
  let pointerDownPos = null;

  const log = (...args) => DEBUG && console.log('[FQA]', ...args);
  const warn = (...args) => DEBUG && console.warn('[FQA]', ...args);
  const group = (label) => DEBUG && console.groupCollapsed(`%c[FQA] ${label}`, 'color:#7b5cff');
  const groupEnd = () => DEBUG && console.groupEnd();

  // Track pointer movement so we can tell drags from clicks
  document.addEventListener('pointerdown', (e) => {
    pointerDownPos = { x: e.clientX, y: e.clientY, t: performance.now() };
  }, true);

  function isDragLike(e) {
    if (!pointerDownPos) return false;
    const dx = Math.abs((e.clientX ?? pointerDownPos.x) - pointerDownPos.x);
    const dy = Math.abs((e.clientY ?? pointerDownPos.y) - pointerDownPos.y);
    const moved = Math.hypot(dx, dy) > DRAG_PX_THRESHOLD;
    if (moved) log('Ignored due to drag-like movement', { dx, dy });
    return moved;
  }

  function isActivationKey(e) {
    return e.key === 'Enter' || e.key === ' ' || e.code === 'Space';
  }

  function findProductItem(fromEl) {
    return fromEl.closest('.product-item');
  }

  function findQuickAddBtn(productItem) {
    // Your markup has both the class and the data-attr; using the class per your note
    return productItem?.querySelector('.quick-add__button');
  }

  function isSoldOut(productItem) {
    // Heuristic: presence of Sold Out badge OR missing has-quickbuy class
    const badge = productItem?.querySelector('.badge-box');
    const text = badge?.textContent?.toLowerCase().trim() || '';
    const soldOutBadge = text.includes('sold out');
    const hasQuickbuyClass = productItem?.classList.contains('product-item--has-quickbuy');
    return soldOutBadge || !hasQuickbuyClass;
  }

  function activateFrom(linkEl, triggerEvent) {
    group('Attempt activation');
    try {
      const productItem = findProductItem(linkEl);
      if (!productItem) {
        warn('No .product-item for clicked .fake-quick-add');
        return;
      }

      const productId =
        productItem.querySelector('[data-quick-add-holder]')?.getAttribute('data-quick-add-holder') ||
        productItem.id ||
        '(unknown)';

      log('Tile context', { productId, productItem });

      if (isSoldOut(productItem)) {
        warn('Sold out / no quick-buy — going to PDP instead', { productId });
        const productHref = productItem.querySelector('a.product-link')?.getAttribute('href');
        if (productHref) {
          window.location.assign(productHref);
        } else {
          warn('No PDP link available for sold-out tile', { productId });
        }
        return;
      }

      const quickAddButton = findQuickAddBtn(productItem);
      if (!quickAddButton) {
        warn('No .quick-add__button inside product item; fallback to PDP');
        const productHref = productItem.querySelector('a.product-link')?.getAttribute('href');
        if (productHref) {
          window.location.assign(productHref);
        }
        return;
      }

      if (quickAddButton.disabled || quickAddButton.getAttribute('aria-disabled') === 'true') {
        warn('Quick add button disabled; skipping');
        return;
      }

      // Defer one frame; avoids collisions with slider click handlers & layout
      requestAnimationFrame(() => {
        log('Dispatching click to real quick-add', { productId, quickAddButton });
        // fire a "trusted-like" click
        quickAddButton.dispatchEvent(
          new MouseEvent('click', { bubbles: true, cancelable: true })
        );
      });
    } finally {
      groupEnd();
    }
  }

  // CLICK handler
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.fake-quick-add');
    if (!link) return;

    // If the user dragged the slider, ignore
    if (isDragLike(event)) return;

    // Prevent anchor navigation & slider from also handling the click
    event.preventDefault();
    event.stopPropagation();

    log('Fake quick add click', { target: event.target, link });
    activateFrom(link, event);
  }, true); // capture early to beat slider libraries

  // KEYBOARD handler (accessibility)
  document.addEventListener('keydown', (event) => {
    if (!isActivationKey(event)) return;
    const link = event.target.closest('.fake-quick-add');
    if (!link) return;

    event.preventDefault(); // prevent page scroll on Space
    event.stopPropagation();

    log('Fake quick add keyboard activation', { key: event.key, link });
    activateFrom(link, event);
  }, true);

  // Optional: on DOM ready, annotate tiles so you can see which ones will work
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-item').forEach((item) => {
      const ok = !!findQuickAddBtn(item) && !isSoldOut(item);
      item.dataset.fqaReady = String(ok);
      if (DEBUG) {
        const id =
          item.querySelector('[data-quick-add-holder]')?.getAttribute('data-quick-add-holder') ||
          item.id || '(unknown)';
        log('Tile readiness', { id, ready: ok });
      }
    });
  });
})();






  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
